export default __webpack_public_path__ + "static/media/new.dbf76213.png";